<template>
  <div id="resetPasswordModal" class="x-modal modal" tabindex="-1" role="dialog" aria-labelledby="resetPasswordTitle" aria-hidden="true">
    <div class="modal-dialog -modal-size -v2 modal-dialog-centered -modal-mobile" role="document">
      <div class="modal-content -modal-content">
        <button type="button" class="close f-1" data-dismiss="modal" aria-label="Close"><i class="fas fa-times"></i></button>
        <div class="modal-header -modal-header"><h2 id="resetPasswordTitle" class="x-title-modal m-auto">ลืมรหัสผ่าน</h2></div>
        <div class="modal-body -modal-body"><PasswordRecoverySupport :support-url="lineLink" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import PasswordRecoverySupport from '@/components/PasswordRecoverySupport.vue'
export default {
  components: { PasswordRecoverySupport }
}
</script>
